import { EActivityStatus, type PartHistory } from '../Service.types';
import { createServerColumnHelper } from '../../shared-compat/DataTable/hooks';

const helper = createServerColumnHelper<PartHistory>();
const ch = helper.accessor;

export function partHistoryTableDef() {
  return [
    ch('activityCrmId', 'string', {
      header: 'Activity Id',
      enableColumnFilter: true,
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id
    }),
    ch('activityStatus', 'string', {
      header: 'Activity Status',
      enableColumnFilter: true,
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id,
      meta: {
        isVisible: false
      }
    }),
    ch('ccn', 'string', {
      header: 'CCN',
      enableColumnFilter: true,
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id
    }),
    ch('partName', 'string', {
      header: 'Part Name',
      enableColumnFilter: true,
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id
    }),
    ch('assetName', 'string', {
      header: 'Asset Name',
      enableColumnFilter: true,
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id
    }),
    ch('usedQuantity', 'string', {
      header: 'Used Quantity',
      enableColumnFilter: true,
      cell: (info) => info.getValue(),
      footer: (props) => props.column.id
    }),
    ch('activityDate', 'date', {
      header: 'Activity Date',
      enableColumnFilter: true,
      meta: { dataType: 'date' },
      cell: (info) => (info.row.original.activityStatus === EActivityStatus.InProgress ? '' : info.getValue()?.toLocaleDateString() ?? ''),
      sortDescFirst: true,
      footer: (props) => props.column.id
    })
  ];
}
